import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { AppStore } from "../services/store/app.store";
import { AuthService } from "../services/auth.service";
import { User } from "../models/user.model";
import { map, catchError, of } from "rxjs";

export const tokenGuard: CanActivateFn = () => {
  const router = inject(Router);
  const appStore = inject(AppStore);
  const authService = inject(AuthService);
  
  // Se non c'è token, vai direttamente al login
  if (!appStore.token()) {
    router.navigate(['/login'], { replaceUrl: true });
    return false;
  }
  
  // Se c'è token ma non c'è utente, prova a recuperare l'utente
  if (!appStore.user()) {
    return authService.me().pipe(
      map((userData) => {
        // Converti IUser in User
        const user = new User(userData);
        appStore.setUser(user);
        return true;
      }),
      catchError((error) => {
        // Se non riesce a recuperare l'utente, fa logout automatico
        authService.triggerSignOut();
        return of(false);
      })
    );
  }
  
  return true;
}; 